import React from 'react'

import MyProgressLoader from 'app/domains/common/Loaders/MyProgressLoader'
import ActivityStatsEmpty from './ActivityStatsEmpty'
import Chart from './Chart'

import './styles.scss'

const ActivitiesGraph = ({ pending, showStats }) => (
  <div className="graph">
    <div className="graph__inner">
      {showStats ? <Chart /> : pending ? <MyProgressLoader /> : <ActivityStatsEmpty />}
    </div>
  </div>
)

export default ActivitiesGraph
